// src/components/BottomNavBar.js

import React, { useContext } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { House, Upload, Gear, UpcScan } from 'react-bootstrap-icons'; // Removed Person as it was never used
import { LanguageContext } from '../contexts/LanguageContext';
import { SettingsContext } from '../contexts/SettingsContext';
import './BottomNavBar.css'; // Import the CSS for BottomNavBar

// Note: We've added a new prop, onBarcodeClick, for opening the Barcode Scanner
const BottomNavBar = ({ onUploadClick, onLoginClick, onHomeClick, onSettingsClick, onBarcodeClick }) => {
  const { translations } = useContext(LanguageContext);
  const { settings } = useContext(SettingsContext);

  // Determine if BottomNavBar should be visible based on layout settings
  const isVisible = settings.layout === 'bottom_only' || settings.layout === 'both';

  if (!isVisible) {
    return null; // Do not render BottomNavBar
  }

  return (
    <Navbar fixed="bottom" className="custom-navbar d-md-none">
      <Nav className="w-100 justify-content-around">
        <Nav.Link href="#" onClick={onHomeClick} className="text-center">
          <House size={24} />
          <div className="nav-label">{translations.home}</div>
        </Nav.Link>
        <Nav.Link href="#" onClick={onUploadClick} className="text-center">
          <Upload size={24} />
          <div className="nav-label">{translations.upload}</div>
        </Nav.Link>
        {/* ADDED FOR BARCODE SCANNER */}
        <Nav.Link href="#" onClick={onBarcodeClick} className="text-center">
          <UpcScan size={24} />
          <div className="nav-label">{translations.scanBarcode}</div>
        </Nav.Link>
        {/* END ADDED FOR BARCODE SCANNER */}
        <Nav.Link href="#" onClick={onSettingsClick} className="text-center">
          <Gear size={24} />
          <div className="nav-label">{translations.settings}</div>
        </Nav.Link>
        {/*
        // Login functionality is not implemented yet.
        // The following login button is commented out to hide it safely.
        <Nav.Link href="#" onClick={onLoginClick} className="text-center">
          <Person size={24} />
          <div className="nav-label">{translations.login}</div>
        </Nav.Link>
        */}
      </Nav>
    </Navbar>
  );
};

export default BottomNavBar;
